/**
 * Mobile Click-to-Call Floating Button
 * Shows a floating call button at the bottom of mobile displays only
 * Hidden on desktop devices
 */

(function() {
  // Configuration
  const config = {
    phoneNumber: '1-888-364-3813',
    buttonText: 'Click here to call',
    buttonIcon: '📞',
    backgroundColor: '#000884',
    textColor: '#FFFFFF',
    position: {
      top: '80px',
      right: '0px'
    },
    maxWidth: 768  // Number, not string!
  };

  // Mobile detection
  function isMobileDevice() {
    // Check screen width
    const isMobileWidth = window.innerWidth <= config.maxWidth;
    
    // Check user agent for mobile devices
    const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    // Check for iOS specifically
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    // Check for touch capability
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    // Return true if mobile width AND (mobile UA OR touch device OR iOS)
    return isMobileWidth && (isMobileUA || isTouchDevice || isIOS);
  }

  // Create the floating button
  function createCallButton() {
    // Check if button already exists
    if (document.getElementById('mobile-call-button')) {
      return;
    }

    // Create button element
    const button = document.createElement('a');
    button.id = 'mobile-call-button';
    button.href = `tel:${config.phoneNumber.replace(/[^0-9+]/g, '')}`;
    button.className = 'mobile-call-button animate-entrance';
    
    // Add icon and text
    button.innerHTML = `
      <span class="call-icon">${config.buttonIcon}</span>
      <span class="call-text">${config.buttonText}</span>
    `;

    // Add styles
    addStyles();
    
    // Append to body
    document.body.appendChild(button);
    
    console.log('📱 Mobile click-to-call button initialized');
  }

  // Add CSS styles
  function addStyles() {
    if (document.getElementById('mobile-call-button-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'mobile-call-button-styles';
    style.textContent = `
      .mobile-call-button {
        position: fixed;
        top: ${config.position.top};
        right: ${config.position.right};
        width: 200px;
        height: 50px;
        background-color: ${config.backgroundColor};
        color: ${config.textColor};
        padding: 0;
        border-radius: 50px 0 0 50px;
        text-decoration: none;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
        font-size: 16px;
        font-weight: 600;
        display: flex !important;
        align-items: center;
        justify-content: center;
        gap: 10px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 999999;
        transition: opacity 0.2s ease, box-shadow 0.2s ease;
        cursor: pointer;
        user-select: none;
        -webkit-user-select: none;
        -webkit-tap-highlight-color: transparent;
        -webkit-touch-callout: none;
        will-change: opacity;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
        transform: translate3d(0, 0, 0);
        -webkit-transform: translate3d(0, 0, 0);
      }

      .mobile-call-button:active {
        opacity: 0.8;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
      }

      .mobile-call-button .call-icon {
        font-size: 20px;
        line-height: 1;
      }

      .mobile-call-button .call-text {
        line-height: 1;
      }

      /* Hide on desktop */
      @media (min-width: ${config.maxWidth + 1}px) {
        .mobile-call-button {
          display: none !important;
        }
      }

      /* Adjust for very small screens */
      @media (max-width: 360px) {
        .mobile-call-button {
          width: 170px;
          right: 0px;
          height: 44px;
          font-size: 14px;
        }
        
        .mobile-call-button .call-icon {
          font-size: 18px;
        }
      }

      /* Animation on page load */
      @keyframes slideUp {
        from {
          opacity: 0;
          right: -200px;
        }
        to {
          opacity: 1;
          right: ${config.position.right};
        }
      }

      .mobile-call-button.animate-entrance {
        animation: slideUp 0.8s ease-out forwards;
        -webkit-animation: slideUp 0.8s ease-out forwards;
      }

      /* iOS Safari safe area support */
      @supports(padding: max(0px)) {
        .mobile-call-button {
          top: calc(80px + env(safe-area-inset-top));
          right: 0px;
        }
      }
    `;
    
    document.head.appendChild(style);
  }

  // Remove button if not mobile
  function removeCallButton() {
    const button = document.getElementById('mobile-call-button');
    if (button) {
      button.remove();
    }
  }

  // Check and toggle button visibility
  function checkAndToggleButton() {
    if (isMobileDevice()) {
      createCallButton();
    } else {
      removeCallButton();
    }
  }

  // Initialize on page load
  function initialize() {
    checkAndToggleButton();
    
    // Re-check on window resize (orientation change, etc.)
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(checkAndToggleButton, 250);
    });
    
    console.log('📞 Click-to-call button controller initialized');
  }

  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  // Global functions for debugging and customization
  window.updateCallButtonConfig = function(newConfig) {
    Object.assign(config, newConfig);
    removeCallButton();
    checkAndToggleButton();
    console.log('📞 Call button config updated:', config);
  };

  window.debugCallButton = function() {
    console.log('╔════════════════════════════════════════════════════════╗');
    console.log('║  Click-to-Call Button Debug Info                      ║');
    console.log('╚════════════════════════════════════════════════════════╝');
    console.log('📱 Is Mobile:', isMobileDevice());
    console.log('📏 Screen Width:', window.innerWidth + 'px');
    console.log('📏 Max Mobile Width:', config.maxWidth + 'px');
    console.log('📞 Phone Number:', config.phoneNumber);
    console.log('🎨 Button Color:', config.backgroundColor);
    console.log('👁️  Button Visible:', !!document.getElementById('mobile-call-button'));
    console.log('─────────────────────────────────────────────────────────');
    
    return {
      isMobile: isMobileDevice(),
      screenWidth: window.innerWidth,
      maxMobileWidth: config.maxWidth,
      buttonExists: !!document.getElementById('mobile-call-button'),
      config: config
    };
  };

  // Expose config for external access
  window.callButtonConfig = config;
})();
